import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Homepage from './pages/Home';
import Login from './login/Login';
import Dashboard from './pages/Dashboard'
import RootLayout from './pages/Root'
import Layout from './pages/Layout'
import Industry from './pages/Industry'
import Category from './pages/Category'
import Subcategory from './pages/Subcategory'
import Profile from './pages/Profile'
import Industryview from  './pages/Industryview'
import Payoutview from './pages/Payoutview'
import Addindustry from './pages/Addindustry'
import AddDocuments from './pages/AddDocuments'
import Editindustry from './pages/Editindustry'
import Addcategory from './pages/Addcategory'
import Editcategory from './pages/Editcategory'
import Viewcategory from './pages/Viewcategory'
import Addsubcategory from './pages/Addsubcategory'
import Editsubcategory from './pages/Editsubcategory'
import Viewsubcategory from './pages/Viewsubcategory'
import Privacypolicy from './pages/Privacypolicy';
import Termsandcondition from './pages/Termsandcondition';
import Payout from './pages/Payout';
import Rating from './pages/Rating';
import Aboutus from './pages/Aboutus';
import Quiz from './pages/Quiz';
import Addquiz from './pages/Addquiz';
import Viewquiz from './pages/Viewquiz';
import Editquiz from './pages/Editquiz';
import Feedback from './pages/Feedback';
import Addfeedback from './pages/Addfeedback';
import Editfeedback from './pages/Editfeedback';
import React from 'react';
import Homeowner from './pages/Homeowner';
import Viewhomeowner from './pages/Viewhomeowner';
import Provider from './pages/Provider';
import Viewprovider from './pages/Viewprovider';
import Employers from './pages/Employers';
import Viewemployer from './pages/Viewemployer';
import Resetpassword from './login/Resetpassword';
import Enteremail from './login/Enteremail';
import Otpverify from './login/Otpverify';
import ExportExcel  from './excelsheet/Excelexport';
import Wallet from './pages/Wallet';
import Transactionhistory from './pages/Transactionhistory';
import Editwallet from './pages/Editwallet';
import Editemployer from './pages/Editemployer';
import Edithomeowner from './pages/Edithomeowner';
import Editprovider from './pages/Editprovider';
import Jobslist from './pages/Jobs';
import Viewjobfeedback from './pages/Viewjob';
import Editjobfeedback from './pages/Editjob';
import ApproveDocument from './pages/ApproveDocument';
import Alljobs from './pages/Joblisting';
import Jobdetails from './pages/Jobdetails';
import Jobupdate from './pages/Jobupdate';
import Adminlisting from './pages/Adminlisting';
import Addadmin from './pages/Addadmin';
import Editadmin from './pages/Editadmin';
import Viewadmin from './pages/Viewadmin';
import DateTimePickerValue from './pages/Datetime';
import Audit from './pages/Audit';
import Credit from './pages/Credit';
import Editcredit from './pages/Editcredit';
import IncompleteUsers from './pages/IncompleteUsers';
import Edituser from './pages/Edituser';
// import Geolocationmap from './map/GooglePlcasesApi';
const router = createBrowserRouter([
  {
    path: '/resetpassword', element: <Resetpassword/>,
  },
  {
    path: '/enteremail', element: <Enteremail/>,
  },
  {
    path: '/verifyotp', element: <Otpverify/>,
  },
  {
    path: '/excelfile', element: <ExportExcel/>,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      {path: '/login', element: <Login/>},
    ]
  },
  {
    path: '/admin',
    element: <RootLayout />,
    children: [
      {path: '/admin/Homepage', element: <Homepage/>},
      {path: '/admin/dashboard', element: <Dashboard />},
      {path: '/admin/industry', element: <Industry />},
      {path: '/admin/category', element: <Category />},
      {path: '/admin/subcategory', element: <Subcategory />},
      {path: '/admin/jobslist', element: <Jobslist />},
      {path: '/admin/jobslist/Viewjobfeedback/:jobid', element: <Viewjobfeedback />},
      {path: '/admin/jobslist/Editjobfeedback/:jobid', element: <Editjobfeedback />},
      {path: '/admin/profile', element: <Profile />},
      {path: '/admin/approveDocument', element: <ApproveDocument />},
      {path: '/admin/industry/industryview/:industryid', element: <Industryview />},
      {path: '/admin/industry/addindustry', element: <Addindustry />},
      {path: '/admin/approveDocument/addDocuments', element: <AddDocuments />},
      {path: '/admin/approveDocument/addDocuments/:user_id', element: <AddDocuments />},
      {path: "/admin/industry/industryedit/:industryid", element: <Editindustry />},
      {path: "/admin/category/addcategory", element: <Addcategory />},
      {path: "/admin/category/editcategory/:categoryid", element: <Editcategory />},
      {path: "/admin/category/viewcategory/:categoryid", element: <Viewcategory />},
      {path: "/admin/subcategory/addsubcategory", element: <Addsubcategory />},
      {path: "/admin/subcategory/editsubcategory/:subcategoryid", element: <Editsubcategory />},
      {path: "/admin/subcategory/viewsubcategory/:subcategoryid", element: <Viewsubcategory />},
      {path: '/admin/privacypolicy', element: <Privacypolicy />},
      {path: '/admin/termsandconditions', element: <Termsandcondition />},
      {path: '/admin/rating', element: <Rating />},
      {path: '/admin/payouts', element: <Payout />},
      {path: '/admin/payouts/payoutview/:payoutid', element: <Payoutview />},
      {path: '/admin/aboutus', element: <Aboutus />},
      {path: '/admin/quiz', element: <Quiz />},
      {path: '/admin/quiz/addquiz', element: <Addquiz />}, 
      {path: '/admin/quiz/viewquiz/:quizid', element: <Viewquiz />},
      {path: '/admin/quiz/editquiz/:quizid', element: <Editquiz />},
      {path: '/admin/feedback', element: <Feedback />},
      {path: '/admin/feedback/addfeedback', element: <Addfeedback />},
      {path: '/admin/feedback/editfeedback/:feedbackid', element: <Editfeedback />}, 
      {path: '/admin/homeowner', element: <Homeowner />},
      {path: '/admin/homeowner/viewhomeowner/:homeownerid', element: <Viewhomeowner />}, 
      {path: '/admin/homeowner/edithomeowner/:homeownerid', element: <Edithomeowner />}, 
      {path: '/admin/provider', element: <Provider />},
      {path: '/admin/provider/viewprovider/:providerid', element: <Viewprovider />},
      {path: '/admin/provider/editprovider/:providerid', element: <Editprovider />},
      {path: '/admin/employers', element: <Employers />},
      {path: '/admin/employers/viewemployer/:employerid', element: <Viewemployer />},
      {path: '/admin/employers/editemployer/:employerid', element: <Editemployer />},
      {path: '/admin/wallet', element: <Wallet />},
      {path: '/admin/wallet/transactionhistory/:userid', element: <Transactionhistory />},
      {path: '/admin/wallet/editwallet/:userid', element: <Editwallet />},
      {path: '/admin/alljobs', element: <Alljobs />},  
      {path: '/admin/alljobs/:jobType/:userId', element: <Alljobs />},  
      {path: '/admin/alljobs/jobdetails/:jobid', element: <Jobdetails />},
      {path: '/admin/alljobs/jobupdate/:jobid', element: <Jobupdate />},  
      {path: '/admin/adminlisting', element: <Adminlisting />},
      {path: '/admin/adminlisting/addadmin', element: <Addadmin />},
      {path: '/admin/adminlisting/editadmin/:userid', element: <Editadmin />},
      {path: '/admin/adminlisting/viewadmin/:userid', element: <Viewadmin />},
      {path: '/admin/datetime', element: <DateTimePickerValue />},
      {path: '/admin/audit', element: <Audit />},
      {path: '/admin/credit', element: <Credit />},
      {path: '/admin/credit/editcredit/:id', element: <Editcredit />},
      {path: '/admin/incompleteusers', element: <IncompleteUsers />},
      {path: '/admin/incompleteusers/edituser/:userid', element: <Edituser />},
    ]
  },
]);

function App() {
  return <RouterProvider router={router} />;
  // return (
  //     <Routes >
  //       <Route path="/" element = {<Login />} />
  //       <Route path="/admin/dashboard" element = {<Dashboard />} />
  //     </Routes >
  // )
}

export default App;
